import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import { WithStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { WithNamespaces, withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
import color from "../../utils/colors";
import SaveIcon from "../../assets/icons/save";
// do not remove the following (needed for setups)
// import SetupIcon from '../../assets/icons/trim';
import CategoriesIcon from "../../assets/icons/categories";
import ExitIcon from "../../assets/icons/exit";
import { withRouter } from "react-router-dom";
import { RouteComponentProps, useHistory } from "react-router";
import { store } from "../../redux/store";
import { exitVehicleConfiguration } from "../../redux/actions";
import { getConfigurationIsDirty } from "../../utils/helpers";
import http from "../../services/http";

export interface NavigationProps {
	warnBeforeExit: () => void;
	saveConfiguration: () => void;
}

const styles: Record<string, CSSProperties> = {
	text: {
		fontSize: "1.3rem",
		lineHeight: "60px",
		verticalAlign: "middle"
	},
	wrapper: {
		padding: "0 10px 0 10px"
	},
	icon: {
		position: "relative" as "relative",
		left: -4,
		top: 2
	},
	navigationWrapper: {
		background: color.darkBackground,
		color: "white"
	},
	link: {
		color: "white",
		textDecoration: "none",
		marginRight: "2.5em"
	}
};

type NavigationCombinedProps = NavigationProps &
	WithNamespaces &
	WithStyles &
	RouteComponentProps<{ modelId: string }>;

export const Navigation: React.FunctionComponent<NavigationCombinedProps> = ({
	classes,
	t,
	match: {
		params: { modelId }
	},
	location: { pathname, hash },
	warnBeforeExit,
	saveConfiguration
}) => {
	const history = useHistory();
	const linkToSetups = `/configuration/${modelId}`;
	const linkToCategories = `/configuration/${modelId}/categories`;

	// don't show categories link on the setups screen, keep layout
	const visibility =
		pathname === linkToSetups
			? ("hidden" as "hidden")
			: ("visible" as "visible");

	const handleConfigurationExitRequest = () => {
		if (getConfigurationIsDirty()) {
			warnBeforeExit();
			return;
		}

		http.dismissUnsavedChanges().then(() => {
			console.log("configuration reset");
		});

		store.dispatch(exitVehicleConfiguration());
		history.push("/main");
	};

	return (
		<div id="navigation-wrapper" className={classes.navigationWrapper}>
			<Grid container spacing={0}>
				<Grid item xs={9}>
					{/* Not the best solution, but sufficent for now: https://stackoverflow.com/questions/38378258/how-to-dispatch-an-action-when-clicking-on-link-when-using-react-router-redux */}
					<Grid container spacing={0}>
						<Grid item align-items="flex-start" xs={6}>
							<span
								className={`clickable ${classes.link}`}
								onClick={handleConfigurationExitRequest}
							>
								<ExitIcon />
								<span className={classes.text}>{t("navigation.exit")}</span>
							</span>
						</Grid>
						<Grid item xs={6} className="alignRight">
							<span
								className={`clickable ${classes.link}`}
								onClick={saveConfiguration}
							>
								<SaveIcon />
								<span className={classes.text}>{t("navigation.save")}</span>
							</span>
							{/* TEMPORARILY HIDE SETUPS SECTION */}
							{/* <Link className={classes.link} to={linkToSetups}>
                                <SetupIcon /><span className={classes.text}>{t('navigation.setups')}</span>
                            </Link> */}
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={3}>
					<Link
						style={{ visibility }}
						className={classes.link}
						to={{
							pathname: linkToCategories
						}}
					>
						<CategoriesIcon />
						<span className={classes.text}>{t("navigation.categories")}</span>
					</Link>
				</Grid>
			</Grid>
		</div>
	);
};

export default withRouter(
	withNamespaces()(withStyles(styles)(Navigation)) as any
);
